import React, { forwardRef } from "react"
import { Circle, Group, Layer, Line, Rect, RegularPolygon, Stage, Text } from "react-konva"
import Konva from "konva"
import { GraphPropContextProvider, useGraphPropContext } from "../GraphPropsContext"
import _ from "lodash"
import { positionFromCenterQuad } from "../../util/fivell_utils"
import { FiveLLRendereProps } from "./FiveLLRenderer"

const Labels = ["인정하는 말", "함께하는\n시간", "선물", "봉사"]

const FiveLLQuadBackground: React.FC = () => {
  const { lm, pmax } = useGraphPropContext()
  const rmax = lm * pmax
  const iconR = lm * 0.1
  const cpr = rmax + iconR * 2

  return (
    <Group>
      <RegularPolygon sides={4} radius={rmax} fill="#ededed" x={lm} y={lm} />
      <RegularPolygon sides={4} radius={rmax * 0.67} fill="#e8e8e8" x={lm} y={lm} />
      <RegularPolygon sides={4} radius={rmax * 0.33} fill="#e1e1e1" x={lm} y={lm} />

      <Line points={[lm, lm, ...positionFromCenterQuad(lm, rmax, 0)]} stroke="white" strokeWidth={1} />
      <Line points={[lm, lm, ...positionFromCenterQuad(lm, rmax, 1)]} stroke="white" strokeWidth={1} />
      <Line points={[lm, lm, ...positionFromCenterQuad(lm, rmax, 2)]} stroke="white" strokeWidth={1} />
      <Line points={[lm, lm, ...positionFromCenterQuad(lm, rmax, 3)]} stroke="white" strokeWidth={1} />
      {_.times(4, () => cpr).map((v, i) => {
        const [x, y] = positionFromCenterQuad(lm, v, i)
        const dimension = { x: x - iconR * 3, y: y + iconR * 1.15, width: iconR * 6, height: lm * 0.08 * 2.4 }
        return (
          <React.Fragment key={i}>
            <Circle radius={iconR} x={x} y={y} fill="#80BDE3" />
            <Text
              text={Labels[i]}
              {...dimension}
              align="center"
              // verticalAlign="middle"
              fill="black"
              fontSize={Math.ceil(lm * 0.085)}
              fontStyle="bold"
            />
            {/*<Rect {...dimension} stroke="black" />*/}
          </React.Fragment>
        )
      })}
    </Group>
  )
}

export const FiveLLQuadRenderer = forwardRef<Konva.Stage, FiveLLRendereProps>((props, ref) => {
  const { width, children, showBorder = false } = props

  return (
    <Stage width={width} height={width} ref={ref}>
      <GraphPropContextProvider width={width} pmax={0.66}>
        {showBorder && (
          <Layer>
            <Rect width={width} height={width} stroke={"1px"} />
          </Layer>
        )}
        <Layer>
          <FiveLLQuadBackground />
          {children}
        </Layer>
      </GraphPropContextProvider>
    </Stage>
  )
})
